export default {
  path: '/purchase-business',
  title: '采购管理',
  icon: 'mdi-purse',
  access: '采购管理',

  children: [
    {
      title: '供应商管理',
      icon: 'mdi-account-group',
      group: '/supplier',
      children: [
        {
          path: '/supplier/personalDetail',
          name: 'supplier-personal-detail',
          component: () =>
            import('@/views/common-business/supplier/supplier-personal-detail'),
          meta: {
            title: '供应商个人信息',
            access: '供应商个人信息:列表',
          },
        },
        {
          path: '/supplier/list3',
          name: 'supplier-main-list3',
          component: () =>
            import('@/views/common-business/supplier/supplier-main-list'),
          meta: {
            title: '合格供应商',
            access: '供应商列表:列表',
            status: '3',
          },
        },
        {
          path: '/supplier/list2',
          name: 'supplier-main-list2',
          component: () =>
            import('@/views/common-business/supplier/supplier-main-list'),
          meta: {
            title: '临时供应商',
            access: '供应商列表:列表',
            status: '2',
          },
        },
        {
          path: '/supplier/list1',
          name: 'supplier-main-list1',
          component: () =>
            import('@/views/common-business/supplier/supplier-main-list'),
          meta: {
            title: '应急供应商',
            access: '供应商列表:列表',
            status: '1',
          },
        },
        {
          path: '/supplier/list4',
          name: 'supplier-main-list4',
          component: () =>
            import('@/views/common-business/supplier/supplier-main-list'),
          meta: {
            title: '慎用供应商',
            access: '供应商列表:列表',
            status: '4',
          },
        },
        {
          path: '/supplier/list5',
          name: 'supplier-main-list5',
          component: () =>
            import('@/views/common-business/supplier/supplier-main-list'),
          meta: {
            title: '黑名单供应商',
            access: '供应商列表:列表',
            status: '5',
          },
        },
        {
          path: '/supplier/list6',
          name: 'supplier-main-list6',
          component: () =>
            import('@/views/common-business/supplier/supplier-main-list'),
          meta: {
            title: '停用供应商',
            access: '供应商列表:列表',
            status: '6',
          },
        },
        {
          path: '/supplier/detail/:id',
          name: 'supplier-detail',
          component: () =>
            import('@/views/common-business/supplier/supplier-detail'),
          meta: {
            title: '供应商详情',
            access: '供应商列表:列表',
            notShowInNav: true,
          },
        },
        {
          path: '/purchase-business/supplier-in-list',
          name: 'supplier-in-list',
          component: () => import('@/views/purchase-business/supplier-in-list'),
          meta: {
            title: '(停用)合格供应商准入',
            access: '供应商准入:列表',
          },
        },
        {
          path: '/purchase-business/supplier-in-detail/:id',
          name: 'supplier-in-detail',
          component: () =>
            import('@/views/purchase-business/supplier-in-detail'),
          meta: {
            title: '(停用)合格供应商准入',
            access: '供应商准入:列表',
            notShowInNav: true,
          },
        },
        {
          path: '/purchase-business/supplier-in/registerSupplier-list',
          name: 'registerSupplier-list',
          component: () =>
            import(
              '@/views/purchase-business/supplier-in/registerSupplier-list'
            ),
          meta: {
            title: '准入申请新版',
            access: '供应商注册准入:列表',
          },
        },
        {
          path: '/purchase-business/supplier-in/registerSupplier-detail/:id',
          name: 'registerSupplier-detail',
          component: () =>
            import(
              '@/views/purchase-business/supplier-in/registerSupplier-detail'
            ),
          meta: {
            title: '供应商申请详情新版',
            access: '供应商注册准入:列表',
            notShowInNav: true,
          },
        },
        {
          path: '/purchase-business/supplier-in/changeSupplierTemporary-list',
          name: 'changeSupplierTemporary-list',
          component: () =>
            import(
              '@/views/purchase-business/supplier-in/changeSupplierTemporary-list'
            ),
          meta: {
            title: '应急转临时供应商',
            access: '应急转临时供应商:列表',
          },
        },
        {
          path: '/purchase-business/supplier-in/changeSupplierQualified-list',
          name: 'changeSupplierQualified-list',
          component: () =>
            import(
              '@/views/purchase-business/supplier-in/changeSupplierQualified-list'
            ),
          meta: {
            title: '临时转合格供应商',
            access: '临时转合格供应商:列表',
          },
        },
        {
          path: '/purchase-business/supplier-in/changeSupplierQualifiedMarket-list',
          name: 'changeSupplierQualifiedMarket-list',
          component: () =>
            import(
              '@/views/purchase-business/supplier-in/changeSupplierQualifiedMarket-list'
            ),
          meta: {
            title: '市场业务转合格供应商',
            access: '市场业务转合格供应商:列表',
          },
        },
        {
          path: '/purchase-business/supplier-in/changeSupplierQualifiedStop-list',
          name: 'changeSupplierQualifiedStop-list',
          component: () =>
            import(
              '@/views/purchase-business/supplier-in/changeSupplierQualifiedStop-list'
            ),
          meta: {
            title: '停用转合格供应商',
            access: '停用转合格供应商:列表',
          },
        },
        {
          path: '/purchase-business/supplier-in/supplier-change-list',
          name: 'supplier-change-list',
          component: () =>
            import(
              '@/views/purchase-business/supplier-in/supplier-change-list'
            ),
          meta: {
            title: '变更准入信息',
            access: '变更准入信息申请:列表',
          },
        },
        {
          path: '/purchase-business/supplier-in/supplier-change-detail/:id',
          name: 'supplier-change-detail',
          component: () =>
            import(
              '@/views/purchase-business/supplier-in/supplier-change-detail'
            ),
          meta: {
            title: '变更准入信息详情',
            access: '变更准入信息申请:列表',
            notShowInNav: true,
          },
        },
        // {
        //   path: '/purchase-business/supplier-in-list2',
        //   name: 'supplier-in-list2',
        //   meta: {
        //     title: '合格供应商评审',
        //     access: '供应商准入:列表',
        //   },
        // },
        {
          path: '/purchase-business/supplier-in-list3',
          name: 'supplier-in-list3',
          meta: {
            title: '(暂不开发)合格供应商复审',
            access: '供应商准入:列表',
          },
        },
        // {
        //   path: '/purchase-business/supplier-in-list4',
        //   name: 'supplier-in-list4',
        //   meta: {
        //     title: '临时供应商准入',
        //     access: '供应商准入:列表',
        //   },
        // },
        {
          path: '/purchase-business/supplier-in/supplier-warning-reward-list',
          name: 'supplier-warning-reward-list',
          component: () =>
            import(
              '@/views/purchase-business/supplier-in/supplier-warning-reward-list'
            ),
          meta: {
            title: '警告与奖励',
            access: '供应商警告与奖励:列表',
          },
        },
        {
          path: '/purchase-business/supplier-in/supplier-warning-reward-detail/:id',
          name: 'supplier-warning-reward-detail',
          component: () =>
            import(
              '@/views/purchase-business/supplier-in/supplier-warning-reward-detail'
            ),
          meta: {
            title: '警告奖励慎用退出详情',
            access: '供应商警告与奖励:列表',
            notShowInNav: true,
          },
        },
        {
          path: '/purchase-business/supplier-in/supplier-caution-list',
          name: 'supplier-caution-list',
          component: () =>
            import(
              '@/views/purchase-business/supplier-in/supplier-caution-list'
            ),
          meta: {
            title: '慎用',
            access: '慎用供应商申请:列表',
          },
        },
        {
          path: '/purchase-business/supplier-in/supplier-black-list',
          name: 'supplier-black-list',
          component: () =>
            import('@/views/purchase-business/supplier-in/supplier-black-list'),
          meta: {
            title: '退出',
            access: '供应商退出申请:列表',
          },
        },
        // 隐藏 2026年7月14日14:01:50
        // {
        //   path: '/purchase-business/supplier-in/supplier-inner-list',
        //   name: 'supplier-inner-list',
        //   component: () =>
        //     import('@/views/purchase-business/supplier-in/supplier-inner-list'),
        //   meta: {
        //     title: '关联供应商',
        //     access: '关联供应商:列表',
        //   },
        // },
        // {
        //   path: '/purchase-business/supplier-in-list7',
        //   name: 'supplier-in-list7',
        //   meta: {
        //     title: '临时转不合格供应商',
        //     access: '供应商准入:列表',
        //   },
        // },
        // {
        //   path: '/purchase-business/supplier-in-list8',
        //   name: 'supplier-in-list8',
        //   meta: {
        //     title: '合格转不合格供应商',
        //     access: '供应商准入:列表',
        //   },
        // },
        {
          path: '/supplier/supplier-assess/list',
          name: 'supplier-assess-list',
          component: () =>
            import(
              '@/views/purchase-business/supplier-assess/supplier-assess-list'
            ),
          meta: {
            title: '供应商合同评审',
            access: '供应商评审:列表',
          },
        },
        {
          path: '/supplier/supplier-assess/supplier-assess-detail/:id',
          name: 'supplier-assess-detail',
          component: () =>
            import(
              '@/views/purchase-business/supplier-assess/supplier-assess-detail'
            ),
          meta: {
            title: '供应商合同评审详情',
            access: '供应商评审:列表',
            notShowInNav: true,
          },
        },
        {
          path: '/supplier/list0',
          name: 'supplier-main-list0',
          component: () =>
            import('@/views/common-business/supplier/supplier-main-list'),
          meta: {
            title: '市场业务供应商',
            access: '供应商列表:列表',
            status: '0',
          },
        },
        // {
        //   path: '/supplier/supplier-assess/supplier-assess-detail-item/:id',
        //   name: 'supplier-assess-detail-item',
        //   component: () =>
        //     import(
        //       '@/views/purchase-business/supplier-assess/private/supplier-assess-detail-item'
        //     ),
        //   meta: {
        //     title: '供应商评审子表详情',
        //     access: '供应商评审:列表',
        //     notShowInNav: true,
        //   },
        // },
      ],
    },
    {
      title: '通讯费管理',
      icon: 'mdi-account-group',
      group: '/communication-fee',
      children: [
        {
          path: '/purchase-business/communication-fee/list',
          name: 'communication-fee-list',
          component: () =>
            import(
              '@/views/purchase-business/communication-fee/communication-fee-list'
            ),
          meta: {
            title: '合同管理',
            access: '通讯费合同:列表',
          },
        },
        {
          path: '/purchase-business/communication-fee/detail/:id',
          name: 'communication-fee-detail',
          component: () =>
            import(
              '@/views/purchase-business/communication-fee/communication-fee-detail'
            ),
          meta: {
            title: '合同管理',
            access: '通讯费合同:列表',
            notShowInNav: true,
          },
        },
        {
          path: '/purchase-business/communication-fee/network-malfunction-list',
          name: 'network-malfunction-list',
          component: () =>
            import(
              '@/views/purchase-business/communication-fee/network-malfunction-list'
            ),
          meta: {
            title: '网络故障',
            access: '网络故障:列表',
          },
        },
        {
          path: '/purchase-business/communication-fee/network-malfunction-detail/:id',
          name: 'network-malfunction-detail',
          component: () =>
            import(
              '@/views/purchase-business/communication-fee/network-malfunction-detail'
            ),
          meta: {
            title: '网络故障详情',
            access: '网络故障:列表',
            notShowInNav: true,
          },
        },
        {
          path: '/purchase-business/communication-fee/communication-fee-pay/list',
          name: 'communication-fee-pay-list',
          component: () =>
            import(
              '@/views/purchase-business/communication-fee/communication-fee-pay-list'
            ),
          meta: {
            title: '通讯费订单',
            access: '通讯费付款:列表',
          },
        },
        {
          path: '/purchase-business/communication-fee/communication-fee-pay-detail/:id',
          name: 'communication-fee-pay-detail',
          component: () =>
            import(
              '@/views/purchase-business/communication-fee/communication-fee-pay-detail'
            ),
          meta: {
            title: '通讯费订单',
            access: '通讯费付款:列表',
            notShowInNav: true,
          },
        },
        // {
        //   path: '/supplier/supplier-assess/supplier-assess-detail-item/:id',
        //   name: 'supplier-assess-detail-item',
        //   component: () =>
        //     import(
        //       '@/views/purchase-business/supplier-assess/private/supplier-assess-detail-item'
        //     ),
        //   meta: {
        //     title: '供应商评审子表详情',
        //     access: '供应商评审:列表',
        //     notShowInNav: true,
        //   },
        // },
      ],
    },
    {
      title: '消防救生检验管理',
      icon: 'mdi-account-group',
      group: '/fire-lifesave-inspection',
      children: [
        {
          path: '/purchase-business/fire-lifesave-inspection/list',
          name: 'fire-lifesave-inspection-contract-list',
          component: () =>
            import(
              '@/views/purchase-business/fire-lifesave-inspection/fire-lifesave-inspection-contract-list'
            ),
          meta: {
            title: '检验合同',
            access: '消防救生检验合同:列表',
          },
        },
        {
          path: '/purchase-business/fire-lifesave-inspection/detail/:id',
          name: 'fire-lifesave-inspection-contract-detail',
          component: () =>
            import(
              '@/views/purchase-business/fire-lifesave-inspection/fire-lifesave-inspection-contract-detail'
            ),
          meta: {
            title: '检验合同',
            access: '消防救生检验合同:列表',
            notShowInNav: true,
          },
        },
        {
          path: '/purchase-business/fire-lifesave-inspection-ship-contract/list',
          name: 'fire-lifesave-inspection-ship-contract-list',
          component: () =>
            import(
              '@/views/purchase-business/fire-lifesave-inspection/fire-lifesave-inspection-ship-contract/fire-lifesave-inspection-ship-contract-list'
            ),
          meta: {
            title: '单船合同',
            access: '消防救生检验单船合同:列表',
          },
        },
        {
          path: '/purchase-business/fire-lifesave-inspection-ship-contract/detail/:id',
          name: 'fire-lifesave-inspection-ship-contract-detail',
          component: () =>
            import(
              '@/views/purchase-business/fire-lifesave-inspection/fire-lifesave-inspection-ship-contract/fire-lifesave-inspection-ship-contract-detail'
            ),
          meta: {
            title: '单船合同',
            access: '消防救生检验单船合同:列表',
            notShowInNav: true,
          },
        },
      ],
    },
    {
      title: '检验与审核管理',
      icon: 'mdi-account-group',
      group: '/survery-audit',
      children: [
        {
          path: '/purchase-business/survery-audit/list',
          name: 'survery-audit-contract-list',
          component: () =>
            import(
              '@/views/purchase-business/survery-audit/survery-audit-contract-list'
            ),
          meta: {
            title: '检验与审核合同',
            access: '检验与审核合同:列表',
          },
        },
        {
          path: '/purchase-business/survery-audit/detail/:id',
          name: 'survery-audit-contract-detail',
          component: () =>
            import(
              '@/views/purchase-business/survery-audit/survery-audit-contract-detail'
            ),
          meta: {
            title: '检验与审核合同详情',
            access: '检验与审核合同:列表',
            notShowInNav: true,
          },
        },
        {
          path: '/purchase-business/survery-audit-ship-contract/list',
          name: 'survery-audit-ship-contract-list',
          component: () =>
            import(
              '@/views/purchase-business/survery-audit/survery-audit-ship-contract/survery-audit-ship-contract-list'
            ),
          meta: {
            title: '检验与审核单船合同',
            access: '检验与审核单船合同:列表',
          },
        },
        {
          path: '/purchase-business/survery-audit-ship-contract/detail/:id',
          name: 'survery-audit-ship-contract-detail',
          component: () =>
            import(
              '@/views/purchase-business/survery-audit/survery-audit-ship-contract/survery-audit-ship-contract-detail'
            ),
          meta: {
            title: '检验与审核船舶合同详情',
            access: '检验与审核单船合同:列表',
            notShowInNav: true,
          },
        },
        {
          path: '/purchase-business/survery-audit-ship-contract-order/list',
          name: 'survery-audit-ship-contract-order-list',
          component: () =>
            import(
              '@/views/purchase-business/survery-audit/survery-audit-ship-contract-order/survery-audit-ship-contract-order-list'
            ),
          meta: {
            title: '检验与审核单船合同订单',
            access: '检验与审核单船合同订单:列表',
          },
        },
        {
          path: '/purchase-business/survery-audit-ship-contract-order/detail/:id',
          name: 'survery-audit-ship-contract-order-detail',
          component: () =>
            import(
              '@/views/purchase-business/survery-audit/survery-audit-ship-contract-order/survery-audit-ship-contract-order-detail'
            ),
          meta: {
            title: '检验与审核船舶合同订单详情',
            access: '检验与审核单船合同订单:列表',
            notShowInNav: true,
          },
        },
      ],
    },
    {
      title: '通导检验管理',
      icon: 'mdi-account-group',
      group: '/communication-audit',
      children: [
        {
          path: '/purchase-business/communication-audit/list',
          name: 'communication-audit-contract-list',
          component: () =>
            import(
              '@/views/purchase-business/communication-audit/communication-audit-contract-list'
            ),
          meta: {
            title: '通导检验年度合同',
            access: '通导检验年度合同:列表',
          },
        },
        {
          path: '/purchase-business/communication-audit/detail/:id',
          name: 'communication-audit-contract-detail',
          component: () =>
            import(
              '@/views/purchase-business/communication-audit/communication-audit-contract-detail'
            ),
          meta: {
            title: '通导检验年度合同详情',
            access: '通导检验年度合同:列表',
            notShowInNav: true,
          },
        },
        // {
        //   path: '/purchase-business/survery-audit-ship-contract/list',
        //   name: 'survery-audit-ship-contract-list',
        //   component: () =>
        //     import(
        //       '@/views/purchase-business/survery-audit/survery-audit-ship-contract/survery-audit-ship-contract-list'
        //     ),
        //   meta: {
        //     title: '检验与审核单船合同',
        //     access: '检验与审核单船合同:列表',
        //   },
        // },
        // {
        //   path: '/purchase-business/survery-audit-ship-contract/detail/:id',
        //   name: 'survery-audit-ship-contract-detail',
        //   component: () =>
        //     import(
        //       '@/views/purchase-business/survery-audit/survery-audit-ship-contract/survery-audit-ship-contract-detail'
        //     ),
        //   meta: {
        //     title: '检验与审核船舶合同详情',
        //     access: '检验与审核单船合同:列表',
        //     notShowInNav: true,
        //   },
        // },
        // {
        //   path: '/purchase-business/survery-audit-ship-contract-order/list',
        //   name: 'survery-audit-ship-contract-order-list',
        //   component: () =>
        //     import(
        //       '@/views/purchase-business/survery-audit/survery-audit-ship-contract-order/survery-audit-ship-contract-order-list'
        //     ),
        //   meta: {
        //     title: '检验与审核单船合同订单',
        //     access: '检验与审核单船合同订单:列表',
        //   },
        // },
        // {
        //   path: '/purchase-business/survery-audit-ship-contract-order/detail/:id',
        //   name: 'survery-audit-ship-contract-order-detail',
        //   component: () =>
        //     import(
        //       '@/views/purchase-business/survery-audit/survery-audit-ship-contract-order/survery-audit-ship-contract-order-detail'
        //     ),
        //   meta: {
        //     title: '检验与审核船舶合同订单详情',
        //     access: '检验与审核单船合同订单:列表',
        //     notShowInNav: true,
        //   },
        // },
      ],
    },
    {
      title: '海图采购管理',
      icon: 'mdi-account-group',
      group: '/materials-purchase',
      children: [
        {
          path: '/purchase-business/materials-purchase/list',
          name: 'materials-purchase-contract-list',
          component: () =>
            import(
              '@/views/purchase-business/materials-purchase/materials-purchase-contract-list'
            ),
          meta: {
            title: '海图采购合同',
            access: '海图采购合同:列表',
          },
        },
        {
          path: '/purchase-business/materials-purchase/detail/:id',
          name: 'materials-purchase-contract-detail',
          component: () =>
            import(
              '@/views/purchase-business/materials-purchase/materials-purchase-contract-detail'
            ),
          meta: {
            title: '海图采购合同详情',
            access: '海图采购合同:列表',
            notShowInNav: true,
          },
        },
        {
          path: '/supply-materials/book-ch',
          name: 'supply-materials-book-ch',
          component: () =>
            import('@/views/maritime-affairs/supply-materials/book/book-ch'),
          meta: {
            title: '中版书价格表',
            access: '中版书价格表:列表',
          },
        },
        {
          path: '/supply-materials/book-en',
          name: 'supply-materials-book-en',
          component: () =>
            import('@/views/maritime-affairs/supply-materials/book/book-en'),
          meta: {
            title: '英版书价格表',
            access: '英版书价格表:列表',
          },
        },
        // {
        //   path: '/supply-materials/book-jpn',
        //   name: 'supply-materials-book-jp',
        //   component: () =>
        //     import('@/views/maritime-affairs/supply-materials/book/book-jp'),
        //   meta: {
        //     title: '日版书（停用）',
        //     access: '日版书:列表',
        //   },
        // },
        // {
        //   path: '/supply-materials/book-mari',
        //   name: 'supply-materials-book-ma',
        //   component: () =>
        //     import('@/views/maritime-affairs/supply-materials/book/book-ma'),
        //   meta: {
        //     title: '海事书（停用）',
        //     access: '海事书:列表',
        //   },
        // },
        {
          path: '/supply-materials/ebook-adp',
          name: 'supply-materials-ebook-adp',
          component: () =>
            import('@/views/maritime-affairs/supply-materials/ebook/ebook-adp'),
          meta: {
            title: 'ADP电子书价格表',
            access: 'ADP电子书价格表:列表',
          },
        },
        {
          path: '/supply-materials/ebook-enp',
          name: 'supply-materials-ebook-enp',
          component: () =>
            import('@/views/maritime-affairs/supply-materials/ebook/ebook-enp'),
          meta: {
            title: 'E-NP电子书价格表',
            access: 'E-NP电子书价格表:列表',
          },
        },
        {
          path: '/supply-materials/chart-en',
          name: 'supply-materials-chart-en',
          component: () =>
            import('@/views/maritime-affairs/supply-materials/chart/chart-en'),
          meta: {
            title: '英版图价格表',
            access: '英版图价格表:列表',
          },
        },
        {
          path: '/supply-materials/chart-na',
          name: 'supply-materials-chart-na',
          component: () =>
            import('@/views/maritime-affairs/supply-materials/chart/chart-na'),
          meta: {
            title: '海军图价格表',
            access: '海军图价格表:列表',
          },
        },
        {
          path: '/supply-materials/chart-ma',
          name: 'supply-materials-chart-ma',
          component: () =>
            import('@/views/maritime-affairs/supply-materials/chart/chart-ma'),
          meta: {
            title: '海事图价格表',
            access: '海事图价格表:列表',
          },
        },
        {
          path: '/supply-materials/chart-jp',
          name: 'supply-materials-chart-jp',
          component: () =>
            import('@/views/maritime-affairs/supply-materials/chart/chart-jp'),
          meta: {
            title: '日版图价格表',
            access: '日版图价格表:列表',
          },
        },
        {
          path: '/supply-materials/chart-yangtze',
          name: 'supply-materials-chart-yangtze',
          component: () =>
            import(
              '@/views/maritime-affairs/supply-materials/chart/chart-yangtze'
            ),
          meta: {
            title: '长江航道图价格表',
            access: '长江航道图价格表:列表',
          },
        },
        {
          path: '/supply-materials/echart-ukho',
          name: 'supply-materials-echart-ukho',
          component: () =>
            import(
              '@/views/maritime-affairs/supply-materials/echart/echart-ukho'
            ),
          meta: {
            title: 'UKHO电子海图价格表',
            access: 'UKHO电子海图价格表:列表',
          },
        },
        {
          path: '/supply-materials/echart-na',
          name: 'supply-materials-echart-na',
          component: () =>
            import(
              '@/views/maritime-affairs/supply-materials/echart/echart-na'
            ),
          meta: {
            title: '海军版电子海图价格表',
            access: '海军版电子海图价格表:列表',
          },
        },
        {
          path: '/supply-materials/echart-ma',
          name: 'supply-materials-echart-ma',
          component: () =>
            import(
              '@/views/maritime-affairs/supply-materials/echart/echart-ma'
            ),
          meta: {
            title: '海事版电子海图价格表',
            access: '海事版电子海图价格表:列表',
          },
        },
        // {
        //   //只支持二级菜单目录，三级目录无法正常显示与使用
        //   title: '海图采购管理',
        //   icon: 'mdi-account-group',
        //   group: '/materials-purchase1',
        //   children: [
        //     {
        //       path: '/purchase-business/communication-audit/list',
        //       name: 'materials-purchase-contract-list1',
        //       component: () =>
        //         import(
        //           '@/views/purchase-business/communication-audit/communication-audit-contract-list'
        //         ),
        //       meta: {
        //         title: '海图采购合同1',
        //         access: '海图采购合同:列表',
        //       },
        //     },
        //   ],
        // },
        // {
        //   path: '/purchase-business/survery-audit-ship-contract/list',
        //   name: 'survery-audit-ship-contract-list',
        //   component: () =>
        //     import(
        //       '@/views/purchase-business/survery-audit/survery-audit-ship-contract/survery-audit-ship-contract-list'
        //     ),
        //   meta: {
        //     title: '检验与审核单船合同',
        //     access: '检验与审核单船合同:列表',
        //   },
        // },
        // {
        //   path: '/purchase-business/survery-audit-ship-contract/detail/:id',
        //   name: 'survery-audit-ship-contract-detail',
        //   component: () =>
        //     import(
        //       '@/views/purchase-business/survery-audit/survery-audit-ship-contract/survery-audit-ship-contract-detail'
        //     ),
        //   meta: {
        //     title: '检验与审核船舶合同详情',
        //     access: '检验与审核单船合同:列表',
        //     notShowInNav: true,
        //   },
        // },
        // {
        //   path: '/purchase-business/survery-audit-ship-contract-order/list',
        //   name: 'survery-audit-ship-contract-order-list',
        //   component: () =>
        //     import(
        //       '@/views/purchase-business/survery-audit/survery-audit-ship-contract-order/survery-audit-ship-contract-order-list'
        //     ),
        //   meta: {
        //     title: '检验与审核单船合同订单',
        //     access: '检验与审核单船合同订单:列表',
        //   },
        // },
        // {
        //   path: '/purchase-business/survery-audit-ship-contract-order/detail/:id',
        //   name: 'survery-audit-ship-contract-order-detail',
        //   component: () =>
        //     import(
        //       '@/views/purchase-business/survery-audit/survery-audit-ship-contract-order/survery-audit-ship-contract-order-detail'
        //     ),
        //   meta: {
        //     title: '检验与审核船舶合同订单详情',
        //     access: '检验与审核单船合同订单:列表',
        //     notShowInNav: true,
        //   },
        // },
      ],
    },
    {
      title: '物资采购',
      icon: 'mdi-ferry',
      group: /spare-parts|repair-manage/,
      children: [
        {
          path: '/spare-parts/enquiry-list',
          name: 'spare-enquiry-list',
          component: () =>
            import(
              '@/views/maritime-maintence/spare-part/enquiry/spare-enquiry-list'
            ),
          meta: {
            title: '备件询价',
            access: '备件询价',
          },
        },
        {
          path: '/spare-parts/enquiry-detail/:id',
          name: 'spare-enquiry-detail',
          component: () =>
            import(
              '@/views/maritime-maintence/spare-part/enquiry/spare-enquiry-detail'
            ),
          meta: {
            title: '备件询价详情',
            access: '备件询价',
            notShowInNav: true,
          },
        },
        {
          path: '/lub-oil/soil-enquiry/list',
          name: 'soil-enquiry-list',
          component: () =>
            import(
              '@/views/maritime-maintence/slide-oil/enquiry/soil-enquiry-list'
            ),
          meta: {
            title: '滑油询价',
            access: '滑油询价',
          },
        },
        {
          path: '/lub-oil/soil-enquiry/detail/:id',
          name: 'soil-enquiry-detail',
          component: () =>
            import(
              '@/views/maritime-maintence/slide-oil/enquiry/soil-enquiry-detail'
            ),
          meta: {
            title: '滑油询价-详情',
            access: '滑油询价',
            notShowInNav: true,
          },
        },
        // {
        //   path: '/lub-oil/union-price-list',
        //   name: 'soil-union-price-list',
        //   component: () =>
        //     import(
        //       '@/views/maritime-maintence/slide-oil/union-price/union-price-list'
        //     ),
        //   meta: {
        //     title: '滑油批量报价',
        //     access: '滑油批量报价',
        //   },
        // },
        {
          path: '/materials/materials-enquiry/list',
          name: 'materials-enquiry-list',
          component: () =>
            import(
              '@/views/maritime-maintence/materials/enquiry/materials-enquiry-list'
            ),
          meta: {
            title: '物料询价',
            access: '物料询价',
          },
        },
        {
          path: '/materials/materials-enquiry/detail/:id',
          name: 'materials-enquiry-detail',
          component: () =>
            import(
              '@/views/maritime-maintence/materials/enquiry/materials-enquiry-detail'
            ),
          meta: {
            title: '物料询价-详情',
            notShowInNav: true,
            access: '物料询价',
          },
        },
        // {
        //   path: '/materials/materials-union-price/list',
        //   name: 'materials-union-price-list',
        //   component: () =>
        //     import(
        //       '@/views/maritime-maintence/materials/union-price/materials-union-price-list'
        //     ),
        //   meta: {
        //     title: '物料批量报价',
        //     access: '物料批量报价',
        //   },
        // },
        // {
        //   path: '/materials/materials-union-price/new',
        //   name: 'materials-union-price-detail',
        //   component: () =>
        //     import(
        //       '@/views/maritime-maintence/materials/union-price/materials-union-price-detail'
        //     ),
        //   meta: {
        //     title: '物料批量报价',
        //     notShowInNav: true,
        //     access: '物料批量报价',
        //   },
        // },
        {
          path: '/repair-manage/voyage-enquiry-list',
          name: 'voyage-enquiry-list',
          component: () =>
            import(
              '@/views/maritime-maintence/repair-manage/voyage-repair/enquiry/voyage-enquiry-list'
            ),
          meta: {
            title: '航修询价',
            access: '航修询价',
          },
        },
        {
          path: '/repair-manage/voyage-enquiry-detail/:id',
          name: 'voyage-enquiry-detail',
          component: () =>
            import(
              '@/views/maritime-maintence/repair-manage/voyage-repair/enquiry/voyage-enquiry-detail'
            ),
          meta: {
            title: '航修询价详情',
            notShowInNav: true,
            access: '航修询价',
          },
        },
      ],
    },
    {
      title: '备件集采',
      icon: 'mdi-dharmachakra',
      group: /special|component-batch-purchase/,
      children: [
        {
          path: '/special/purchase/component-standType-list',
          name: 'component-standType-list',
          component: () =>
            import(
              '@/views/purchase-business/component-batch-purchase/component-standType-list'
            ),
          meta: {
            title: '采购标准化类别',
            access: '备件标准化分类:列表',
          },
        },
        {
          path: '/special/purchase/component-batch-purchase-list',
          name: 'component-batch-purchase-list',
          component: () =>
            import(
              '@/views/purchase-business/component-batch-purchase/component-batch-purchase-list'
            ),
          meta: {
            title: '机务集采',
            access: '备件专项集采:列表',
            type: '机务',
          },
        },
        {
          path: '/special/purchase/component-batch-purchase-detail/:id',
          name: 'component-batch-purchase-detail',
          component: () =>
            import(
              '@/views/purchase-business/component-batch-purchase/component-batch-purchase-detail'
            ),
          meta: {
            title: '备件专项集采详情',
            access: '备件专项集采:列表',
            notShowInNav: true,
            // type: '机务',
          },
        },
        {
          path: '/special/purchase/component-batch-purchase-listTD',
          name: 'component-batch-purchase-listTD',
          component: () =>
            import(
              '@/views/purchase-business/component-batch-purchase/component-batch-purchase-listTD'
            ),
          meta: {
            title: '通导集采',
            access: '通导专项集采:列表',
            type: '通导',
          },
        },
        // {
        //   path: '/special/purchase/component-batch-purchase-detail/:id',
        //   name: 'component-batch-purchase-detail',
        //   component: () =>
        //     import(
        //       '@/views/purchase-business/component-batch-purchase/component-batch-purchase-detail'
        //     ),
        //   meta: {
        //     title: '通导专项集采详情',
        //     access: '通导专项集采:列表',
        //     notShowInNav: true,
        //     type: '通导',
        //   },
        // },
      ],
    },
    {
      title: '设备集采',
      icon: 'mdi-dharmachakra',
      group: /special|engine-batch-purchase/,
      children: [
        {
          path: '/special/purchase/engine-batch-purchase-list',
          name: 'engine-batch-purchase-list',
          component: () =>
            import(
              '@/views/purchase-business/engine-batch-purchase/engine-batch-purchase-list'
            ),
          meta: {
            title: '机务集采',
            access: '备件专项集采:列表',
            type: '机务',
          },
        },
        {
          path: '/special/purchase/engine-batch-purchase-detail/:id',
          name: 'engine-batch-purchase-detail',
          component: () =>
            import(
              '@/views/purchase-business/engine-batch-purchase/engine-batch-purchase-detail'
            ),
          meta: {
            title: '设备专项集采详情',
            access: '备件专项集采:列表',
            notShowInNav: true,
            // type: '机务',
          },
        },
        {
          path: '/special/purchase/engine-batch-purchase-listTD',
          name: 'engine-batch-purchase-listTD',
          component: () =>
            import(
              '@/views/purchase-business/engine-batch-purchase/engine-batch-purchase-listTD'
            ),
          meta: {
            title: '通导集采',
            access: '通导专项集采:列表',
            type: '通导',
          },
        },
      ],
    },
    {
      title: '物料集采',
      icon: 'mdi-format-paint',
      group: '/procurement',
      children: [
        // {
        //   path: '/materials/materials-union-price/list',
        //   name: 'materials-union-price-list',
        //   component: () =>
        //     import(
        //       '@/views/maritime-maintence/materials/union-price/materials-union-price-list'
        //     ),
        //   meta: {
        //     title: '物料协议价',
        //     access: '物料协议价',
        //   },
        // },
        // {
        //   path: '/materials/materials-union-price/new',
        //   name: 'materials-union-price-detail',
        //   component: () =>
        //     import(
        //       '@/views/maritime-maintence/materials/union-price/materials-union-price-detail'
        //     ),
        //   meta: {
        //     title: '物料协议价',
        //     notShowInNav: true,
        //     access: '物料协议价',
        //   },
        // },
        {
          path: '/procurement/procurement-union-price/list05',
          name: 'procurement-union-price-list05',
          component: () =>
            import(
              '@/views/maritime-maintence/materials/union-price/materials-union-price-list'
            ),
          meta: {
            title: '物料协议价',
            access: '季度物料协议价',
            subjectId: '其他', //其他
          },
        },
        {
          path: '/procurement/purchase/material-batch-purchase-list',
          name: 'material-batch-purchase-list',
          component: () =>
            import(
              '@/views/purchase-business/material-batch-purchase/material-batch-purchase-list'
            ),
          meta: {
            title: '物料集采',
            access: '物料专项集采:列表',
          },
        },
        {
          path: '/procurement/purchase/material-batch-purchase-detail/:id',
          name: 'material-batch-purchase-detail',
          component: () =>
            import(
              '@/views/purchase-business/material-batch-purchase/material-batch-purchase-detail'
            ),
          meta: {
            title: '物料集采',
            access: '物料专项集采:列表',
            notShowInNav: true,
          },
        },
      ],
    },
    {
      title: '大宗集采',
      icon: 'mdi-water-sync',
      group: /lub-oil|materials|beijian/,
      children: [
        {
          path: '/lub-oil/union-price-list',
          name: 'soil-union-price-list',
          component: () =>
            import(
              '@/views/maritime-maintence/slide-oil/union-price/union-price-list'
            ),
          meta: {
            title: '滑油协议价',
            access: '滑油协议价',
          },
        },
        {
          path: '/lub-oil/union-price-new',
          name: 'soil-union-price-detail',
          component: () =>
            import(
              '@/views/maritime-maintence/slide-oil/union-price/union-price-detail'
            ),
          meta: {
            title: '滑油协议价',
            access: '滑油协议价',
            notShowInNav: true,
          },
        },
        {
          path: '/lub-oil/additional-price-new',
          name: 'soil-additional-price-detail',
          component: () =>
            import(
              '@/views/maritime-maintence/slide-oil/union-price/union-price-detail'
            ),
          meta: {
            title: '滑油附加价',
            access: '滑油协议价',
            notShowInNav: true,
          },
        },
        {
          path: '/materials/materials-union-price/list01',
          name: 'materials-union-price-list01',
          component: () =>
            import(
              '@/views/maritime-maintence/materials/union-price/materials-union-price-list'
            ),
          meta: {
            title: '油漆协议价',
            access: '油漆协议价',
            subjectId: '1581991857076989953', //油漆费
          },
        },
        {
          path: '/materials/materials-union-price/list02',
          name: 'materials-union-price-list02',
          component: () =>
            import(
              '@/views/maritime-maintence/materials/union-price/materials-union-price-list'
            ),
          meta: {
            title: '化学品协议价',
            access: '化学品协议价', //后台权限相关
            subjectId: '1581991857064407043', //化学品
          },
        },
        {
          path: '/materials/materials-union-price/list03',
          name: 'materials-union-price-list03',
          component: () =>
            import(
              '@/views/maritime-maintence/materials/union-price/materials-union-price-list'
            ),
          meta: {
            title: '缆绳协议价',
            access: '缆绳协议价',
            subjectId: '1581991856967938050', //缆绳
          },
        },
        {
          path: '/materials/materials-union-price/list04',
          name: 'materials-union-price-list04',
          component: () =>
            import(
              '@/views/maritime-maintence/materials/union-price/materials-union-price-list'
            ),
          meta: {
            title: '绑扎件协议价',
            access: '绑扎件协议价',
            subjectId: '1581991857072795650', //绑扎件
          },
        },
        {
          path: '/beijian/union-price-list',
          name: 'union-price-list',
          component: () =>
            import(
              '@/views/maritime-maintence/spare-part/union-price/union-price-list'
            ),
          meta: {
            title: '锚锚链协议价',
            access: '锚和锚链协议价',
          },
        },
        {
          path: '/beijian/union-price-new',
          name: 'union-price-detail',
          component: () =>
            import(
              '@/views/maritime-maintence/spare-part/union-price/union-price-detail'
            ),
          meta: {
            title: '锚锚链协议价',
            notShowInNav: true,
            access: '锚和锚链协议价',
          },
        },
        // {
        //   path: '/materials/materials-union-price/list05',
        //   name: 'materials-union-price-list05',
        //   component: () =>
        //     import(
        //       '@/views/maritime-maintence/materials/union-price/materials-union-price-list'
        //     ),
        //   meta: {
        //     title: '其他物料协议价',
        //     access: '物料协议价',
        //     subjectId: '其他', //其他
        //   },
        // },
        {
          path: '/materials/materials-union-price/new',
          name: 'materials-union-price-detail',
          component: () =>
            import(
              '@/views/maritime-maintence/materials/union-price/materials-union-price-detail'
            ),
          meta: {
            title: '物料协议价',
            notShowInNav: true,
            access: '物料协议价',
          },
        },
        // {
        //   path: '/spare-parts/union-price-list',
        //   name: 'union-price-list',
        //   component: () =>
        //     import(
        //       '@/views/maritime-maintence/spare-part/union-price/union-price-list'
        //     ),
        //   meta: {
        //     title: '备件批量报价',
        //     access: '备件批量报价',
        //   },
        // },
        // {
        //   path: '/spare-parts/union-price-new',
        //   name: 'union-price-detail',
        //   component: () =>
        //     import(
        //       '@/views/maritime-maintence/spare-part/union-price/union-price-detail'
        //     ),
        //   meta: {
        //     title: '备件批量报价-详情',
        //     access: '备件批量报价',
        //     notShowInNav: true,
        //   },
        // },
        // group: /spare-parts|lub-oil|materials|repair-manage|special/,
      ],
    },
  ],
}
